import { css } from "styled-components";

const AccordionCss = css`
  .content-accordion {
    border-bottom: 2px solid rgba(255, 255, 255, 0.7);

    &-header {
      && {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 2px solid rgba(255, 255, 255, 0.7);
        font-size: 1.2em;
      }

      &-image {
        && {
          width: auto;
          height: 44px;
        }
      }

      &-literal {
        padding: 15px;
      }

      &-arrow {
        && {
          transform: rotate(0deg);
          margin: 10px;
          height: 12px;
          width: auto;
          transition: transform 0.2s ease 0s;
          transform-origin: center center;
        }
      }

      &.ui-state-active {
        .content-accordion-header-arrow {
          transform: rotate(180deg);
          transition: transform 0.2s ease 0s;
          transform-origin: center center;
        }
      }
    }

    &-content {
      padding: 15px;
    }
  }
`;
export default AccordionCss;
